import { createSuspenseComponent } from 'src/utils/suspense-companion/createSuspenseComponent';
import component from './Header';
import hook from './useHeader';

export default createSuspenseComponent({ component, hook });
